
import type { Product } from './types';

export const motulProducts: Product[] = [
  {
    id: 'motul1',
    shopId: '',
    name: 'MOTUL 300V ROAD RACING 5W-40',
    brand: 'moutl',
    price: 100, // UPDATED
    image: 'https://www.motul.com/_next/image?url=https%3A%2F%2Fazupim01.motul.com%2Fmedia%2FmotulData%2FIM%2Fbigweb%2FMOTUL_104115_300V%2520RR%25205W-40_4L_NEW_png.png&w=1080&q=75',
    description: '300V Fully synthetic racing oil for the highest performance engines.',
    category: 'oil',
  },
  {
    id: 'motul2',
    shopId: '',
    name: 'MOTUL 8100 ECO-LITE 0W-30',
    brand: 'moutl',
    price: 120, // UPDATED
    image: 'https://www.motul.com/_next/image?url=https%3A%2F%2Fazupim01.motul.com%2Fmedia%2FmotulData%2FIM%2Fbigweb%2FMotul_110889_8100_ECO_LITE_0W30_5L_png.png&w=1080&q=75',
    description: '100% synthetic engine oil with fuel economy for modern gasoline engines.',
    category: 'oil',
  },
  {
    id: 'motul3',
    shopId: '',
    name: 'MOTUL 8100 POWER 5W-30',
    brand: 'moutl',
    price: 110, // UPDATED
    image: 'https://www.motul.com/_next/image?url=https%3A%2F%2Fazupim01.motul.com%2Fmedia%2FmotulData%2FIM%2Fbigweb%2FMotul_111801_8100_POWER_5W30_5L_png.png&w=1080&q=75',
    description: 'High performance synthetic oil for powerful engines.',
    category: 'oil',
  },
  {
    id: 'motul4',
    shopId: '',
    name: 'MOTUL FORK OIL FACTORY LINE MEDIUM 10W',
    brand: 'moutl',
    price: 20, // UPDATED
    image: 'https://www.motul.com/_next/image?url=https%3A%2F%2Fazupim01.motul.com%2Fmedia%2FmotulData%2FIM%2Fbigweb%2Fmotul_105925_fork_oil_fl_medium_1l_png.png&w=1080&q=75',
    description: 'Medium viscosity fork oil, Factory Line for suspension forks.',
    category: 'fork oil',
  },
];
